import { noop } from 'svelte/internal';
import Enquiry from './enquiry/Enquiry.svelte';
import Example from './Example.svelte';
if (!isProduction && document.querySelector('#example')) {
    new Example({ target: document.querySelector('#example') });
}
globalThis['enquiryWidget'] = {
    version: VERSION,
    environment: isProduction ? 'production' : 'development',
    Enquiry: Enquiry
};
createCustomElement('enquiry-form', Enquiry, {
    props: {
        config: string,
        layout: options("default", "simple")
    },
    members: {
        set value(value) {
            this.element.setValue(value);
        },
        get value() {
            return this.element.getValue();
        },
        reset() {
            this.element.reset();
        }
    }
});
function createCustomElement(tagName, Component, options = {}, BaseHTMLElement = HTMLElement, defineOptions) {
    const props = options.props || {};
    const init = options.init || noop;
    const members = options.members || {};
    const customElement = class extends BaseHTMLElement {
        constructor() {
            super();
        }
        static get observedAttributes() { return Object.keys(props).map(dashCase); }
        connectedCallback() {
            const properties = Object.keys(props).reduce((o, name) => ({
                ...o,
                [name]: props[name](this.getAttribute(dashCase(name))),
            }), {});
            init.call(this, properties);
            this.element = new Component({
                target: this,
                props: {
                    host: this,
                    ...properties,
                }
            });
        }
        attributeChangedCallback(name, oldValue, newValue) {
            var _a;
            name = camelCase(name);
            (_a = this.element) === null || _a === void 0 ? void 0 : _a.$set({ [name]: props[name](newValue) });
        }
        disconnectedCallback() {
            this.element.$destroy();
            this.element = null;
        }
    };
    for (const name of Object.keys(members)) {
        const prop = Object.getOwnPropertyDescriptor(members, name);
        Object.defineProperty(customElement.prototype, name, prop);
    }
    insertStyle(options.style);
    customElements.define(tagName, customElement, defineOptions);
    function dashCase(value) {
        return value.replace(/[A-Z]/g, m => "-" + m.toLowerCase());
    }
    function camelCase(value) {
        return value.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
    }
    function insertStyle(css) {
        if (css) {
            var style = document.createElement('style');
            style.textContent = css;
            const fistStyle = document.head.querySelector('style, link');
            fistStyle ? document.head.insertBefore(style, fistStyle) : document.head.appendChild(style);
        }
    }
}
function stringWithDefault(def) { return (value) => value || def; }
function string(value) { return value; }
function int(value) { return parseInt(value); }
function boolean(value) { return typeof value === 'string' && value !== 'false'; }
function booleanWithDefault(def) { return (value) => value == undefined ? def : boolean(value); }
function options(...values) { return (value) => values.indexOf(value) === -1 ? values[0] : values[values.indexOf(value)]; }
